import { render } from "./AppShellPopups.vue?vue&type=template&id=44b92c4c"
import script from "./AppShellPopups.vue?vue&type=script&lang=js"
export * from "./AppShellPopups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__